import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'default',
})
export class DefaultPipe implements PipeTransform {
  constructor() {}

  /**
   * @param  {any} value
   * @param  {defaultValue} defaultValue? Default to display if the value is null or empty
   * @returns any
   */
  transform(
    value: string,
    defaultValue: string,
    options: { ifEmptyString?: boolean } = {}
  ): any {
    if (value === undefined) {
      return defaultValue;
    } else if (options.ifEmptyString && value === '') {
      return defaultValue;
    } else return value;
  }
}
